import React, { Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import $ from 'jquery';
import Select from 'react-select';
import { lang } from '../Helpers/lang';
import { PageTitle, CheckAuth } from "../Helpers/SettingHelper";
import { apiUrl} from'../Config/Config';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';

const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();
	// etc... other react-router-dom v6 hooks
  
	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
		// etc...
	  />
	);
  };

class Edit extends Component {

	constructor(props)
	{
		CheckAuth();
		super(props);	
	    const vehicle_id = (typeof this.props.params.ID === 'undefined') ? '' : this.props.params.ID;
		this.state = {
            vehicle_id: vehicle_id,
			vehicle_name:'',
			vehicle_price:'',
			selectedOption:{ value: 'active', label: 'Active'},
			selectedvalue:'',
			editid:0,
			image_preview:'',
			image_name:'',
			image:'',
			old_image:'',
			fileExtension:'',
		};
		// this.props.getCategoryDetailList(vehicle_id);
		var qs = require('qs');
		var catid = this.state.vehicle_id;

		axios.get(apiUrl+"Vehicles/listdetail?id="+catid).then(res => {
			this.setState({vehicle_name:res.data.vehiclelist.vehicle_name,vehicle_price:res.data.vehiclelist.vehicle_km_price});
			this.setState({editid:1,image_preview:res.data.vehiclelist.image,old_image:res.data.vehiclelist.image})
			if(res.data.vehiclelist.status === 'A'){
				this.setState({selectedOption:{value: 'active', label: 'Active'}});
			}else{
			this.setState({selectedOption:{value: 'inactive', label: 'Inactive'}});
			}
		}); 		
		
		this.handleInputChange = this.handleInputChange.bind(this);
	    this.handleChange = this.handleChange.bind(this);

    }

	handleChange = (r,selOption) => {
       
		if(r == 'status'){
			this.setState({selectedOption:selOption})
			this.setState({  selectedvalue : selOption.value});
		}
 	};
   handleInputChange(event) {
      const {name, value} = event.target;      
      this.setState({
          [name]: value
        });
     		
    }


	componentDidMount() {
		document.title = PageTitle('Vehicle Edit');
    }

	onChangeHandler=event=>{
		let reader = new FileReader();
		const file = event.target.files[0];
		const extension = file.name.split('.').pop();
		reader.onloadend = () => {
		  this.setState({
			image_name: file.name,
			image_preview: reader.result,
			image: file,
			fileExtension:extension,editid:0
		  });
		};
		reader.readAsDataURL(file);
	}
        handleFormSubmit = () => {
			if(this.validateForm()){ 
				this.setState({Loading:true});
				const formPayload = this.state;
				var qs = require('qs');
				var status = '';
				if(formPayload.selectedvalue === '' && formPayload.selectedvalue!== 0){
				status =formPayload.selectedOption.value;
				}else{
				status = formPayload.selectedvalue;
				}

				var postObject = {
					admin_id : localStorage.getItem("admin_id"),
					vehicle_name: formPayload.vehicle_name,
					vehicle_price: formPayload.vehicle_price,
					status:  status,
					id: formPayload.vehicle_id,
					editid:  this.state.editid,
					// old_image:  this.state.old_image,
					// image: this.state.editid===0 ? formPayload.image:'',				
				};

				let formData = new FormData();
				for(let k in postObject) {
				formData.append(k, postObject[k]);
				}		       
				axios.post(apiUrl+"Vehicles/edit",formData ).then(res => {
					if(res.data.status === "success"){	
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
								setTimeout(
								function() {
									$('.success_message').html(this.props.navigate('/vehicles'));
								}
								.bind(this),
								3000
								);
					}else{
						$('.success_message').html('<div class="status_sucess"><h3>'+res.data.message+'</h3></div>');
						
						setTimeout(
						function() {
							$('.success_message').html('');
						}
						.bind(this),
						3000
						);
						this.setState({Loading:false});
					}
				});
			}
	}

	validateForm() {
		const {vehicle_name, vehicle_price, image} = this.state;
		
		let errors = {};
		let formIsValid = true;

		if (!vehicle_name) {
			formIsValid = false;
			$('.errorvehiclename').html('<span class="errorspan">Please fill the field</span>');
		}else if(vehicle_name){
			//if (/^[a-zA-Z\s]*$/.test(vehicle_name)) {
			$('.errorvehiclename').html('');
			// }else{
			// 	formIsValid = false;
			// 	$('.errorvehiclename').html('Please enter valid vehicle name');
			// }
		}	

		if (!vehicle_price) {
			formIsValid = false;
			$('.errorvehicleprice').html('<span class="errorspan">Please fill the field</span>');
		}else if(vehicle_price){
			//if (/^[a-zA-Z\s]*$/.test(vehicle_price)) {
			$('.errorvehicleprice').html('');
			// }else{
			// 	formIsValid = false;
			// 	$('.errorvehicleprice').html('Please enter valid vehicle name');
			// }
		}	
		if (this.state.editid==0) {
			// if (!image) {
				
			// 	formIsValid = false;
			// 	$('.errorfile').html('<span class="errorspan">Please fill the feild</span>');
			// 		}else{
			// 			$('.errorfile').html('');
			// 		}
			// 		if (image) {		
			// if (!image.name.match(/\.(jpg|jpeg|png|svg)$/)) {
				
			// 	formIsValid = false;
			// 		 $('.errorfile').html('<span class="errorspan">Please select valid type</span>');
				   
			//   }else{
			// 	$('.errorfile').html('');
			//   }
			// }
		}
		this.setState({
			errors: errors
		});
		return formIsValid;
	}
  render() {

  	  const {selectedOption} = this.state;	

		// if(this.state.editid==1){
			
		// 	console.log(1)
		// 	var loaderimg = vehicleURL+'/' +this.state.image_preview;
		// 	var preview = <img className="img_class" src={loaderimg} alt="" />;
		// }else {
		
			
		// 	console.log(2) 
		// 	var	preview = <img className="img_class" src={this.state.image_preview} alt="" />;
	
		// }
  	
    return (
      <div className="wrapper"> 
 
	  <Header />
    <MenuSidebar currentpage="vehicles" />  
      <div className="content">	
		<div className="content-wrapper">
		<div class="content-wrapper-before"></div>
			<div className="form-wrapper leaa-admin-head card">
			<div className="success_message"></div>
			<div>
				<a class="primary-btn" href="/vehicles">Back</a>
			</div>
			<div className="title">
				<h4>Edit Details</h4>
			</div>
			 <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} encType="multipart/form-data">
			<div className="form-row">
			<div className="form-left">
				<div className="form-group">
					<label>Vehicle<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="text" name="vehicle_name" onChange={this.handleInputChange} className="form-control" value={this.state.vehicle_name} />
					<div className="errorvehiclename"></div>
				</div>	
				<div className="form-group">					
					<label>Status<span class="required" style={{ color: "red" }} > * </span> :</label>
						   <Select 
						   value={selectedOption?selectedOption:{ value: 'active', label: 'Active'}}
                            options={lang.common.status_option} 
                            onChange={this.handleChange.bind(this, 'status')}
                            />
	           </div> 		
			</div>
                  
			<div className="form-right">
				<div className="form-group">
					<label>Price per mile($)<span class="required" style={{ color: "red" }} > * </span> : </label>
				    <input type="text" name="vehicle_price" onChange={this.handleInputChange} className="form-control" value={this.state.vehicle_price} />
					<div className="errorvehicleprice"></div>
				</div>	
               

			</div>	
			</div>		



			<div className="btn-group export">	
				  <button className="btn btn_orange btn_minwid login_submit animate-btn2" type="submit" disabled={(this.state.Loading ===true)?true:false}> {this.state.Loading ===true?
                                        <span>updating</span>:<span>Submit</span>
                                        }
                   </button>
			</div>
			</form>
			</div>				
		</div>	
	</div>
		 	
    </div>
    );
  }
}


export default (withRouter(Edit));